import type { TypedDocumentNode } from "@graphql-typed-document-node/core";
import type { Data } from "figures/TRAJECTORIES_EXPLORER_SIMULATION";
import { print } from "graphql";
import type { Draft } from "immer";
import { createContext } from "react";

export type { CountryId } from "./country";
export type { RegionId } from "./region";

export interface ExplorerContext {
  status: "idle" | "fetching" | "data" | "error";
  errorMessage?: string;
  controls: {
    countries: Array<{ value: string; label: string }>;
  };
  data: {
    trajectories: Data;
  };
}
interface ContextState {
  immer: [ExplorerContext, (f: (draft: Draft<ExplorerContext>) => undefined | ExplorerContext) => void];
}

export const explorerDefaultState: ExplorerContext = {
  status: "idle",
  controls: {
    countries: [],
  },
  data: { trajectories: [] },
};

export const ExplorerContext = createContext<ContextState>({
  immer: [explorerDefaultState, () => explorerDefaultState],
});

export type View = "countries" | "disparities";

export async function explorerQuery<R, V>(document: TypedDocumentNode<R, V>, variables: V): Promise<R> {
  const response = await fetch("https://unesco-learning-trajectories-data.vercel.app/api/trajectories", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ query: print(document), variables }),
  });
  if (!response.ok) {
    throw new Error(`Explorer API request failed: ${response.status} ${response.statusText}`);
  }

  const { data, errors } = await response.json();
  if (errors?.length) {
    throw new Error(errors.map((e: { message: string }) => e.message).join("\n"));
  }

  return data;
}

export type Series = "SIMULATION_ACCESS" | "SIMULATION_LEARNING" | "CURRENT" | "COMPARISON";
